import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { BIOMETRY_PATH } from '../../data/biometrics.constants';
import { routesData } from '../../resources/routes.constant';
import { MoreInfoService } from '../../services/more-info.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
  showNewFooter: boolean = false;
  footerLite: string = 'false';
  footerError: string = 'false';
  isCDTConfig: string = 'false';
  isBiometrics: string = 'false';
  whiteHeader: string = 'false';
  constructor(
    public moreInfoService: MoreInfoService,
    public router: Router,
    public ref: ChangeDetectorRef
  ) {
    this.observeRoutes();
  }

  ngOnInit(): void {
    this.showNewFooter = this.moreInfoService.moreInfoData.landing2022;
    const footerEvaluate = setInterval(() => {
      this.showNewFooter = this.moreInfoService.moreInfoData.landing2022;
      if (this.moreInfoService.moreInfoData.getParams) {
        clearInterval(footerEvaluate);
      }
    }, 1000);
  }
  observeRoutes() {
    this.router.events
      .pipe(filter((e) => e instanceof NavigationEnd))
      .subscribe((e: NavigationEnd) => {
        const url = e.url.split('?')[0];

        this.footerLite =
          url === routesData.HOME.redirectPath ? 'false' : 'true';

        this.footerError =
          url === routesData.ERRORS.GENERAL_ERROR.redirectPath ||
          url === routesData.ERRORS.USER_ERROR.redirectPath ||
          url === routesData.ERRORS.OTP_ERROR.redirectPath ||
          url === routesData.ERRORS.NO_ACCOUNTS_ERROR.redirectPath ||
          url === routesData.ERRORS.PSE_ERROR.redirectPath ||
          url === routesData.ERRORS.PSE_PENDING_ERROR.redirectPath ||
          url === routesData.ERRORS.TIME_ERROR.redirectPath
            ? 'true'
            : 'false';

        this.isCDTConfig =
          e.url === routesData.CDT_CONFIGURATION.redirectPath
            ? 'true'
            : 'false';
        this.whiteHeader =
          url === routesData.CHANNEL_ENROLLMENT.redirectPath ? 'true' : 'false';
        this.isBiometrics = url.includes(BIOMETRY_PATH) + '';
        this.ref.detectChanges();
      });
  }
}
